import {
  AppBar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Toolbar,
  Typography
} from "@material-ui/core";
import React from "react";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { withRouter } from "react-router-dom";
import { SECTIONS } from "../../../constants/appConstants";
import {
  IsSectionVisible,
  IsTenant,
  IsTenantAdmin,
  PaperComponent
} from "../../../utils/helper";

class TenantViewTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenantList: props.tenantList ? props.tenantList : [],
      viewAllSuite: false,
      selectedServiceLocations: ""
    };
  }

  componentDidMount() {
    /**
     * fetch list data
     */
  }

  /**
   * tenant list data
   * @param {*} newProps
   */
  componentWillReceiveProps(newProps) {
    if (this.tenantList !== newProps.tenantList) {
      this.setState({ tenantList: newProps.tenantList });
    }
  }

  /**
   * call on view suit click
   * @param {*} viewAllSuite
   * @param {*} serviceLocations
   */
  handleViewSuite = (viewAllSuite = false, serviceLocations) => {
    this.setState({
      viewAllSuite: viewAllSuite,
      selectedServiceLocations: serviceLocations
    });
  };

  render() {
    const { tenantList, viewAllSuite, selectedServiceLocations } = this.state;

    const TenantListing = IsSectionVisible(
      SECTIONS.TENANT,
      SECTIONS.TENANT_LIST
    );

    const filteredTenantList =
      IsTenant() && !IsTenantAdmin()
        ? tenantList.filter(f => f.UsersCount > 0)
        : tenantList;

    return (
      <div className={"tenant-view-table-div"}>
        {TenantListing ? (
          <table
            className={"tenant-view-table"}
            style={{ fontWeight: "200 !important" }}
          >
            <thead>
              <tr
                className={"header-blue"}
                style={{ borderTop: "3px solid #FFFFFF" }}
              >
                <th className={"w-25"} align={"left"}>
                  {" "}
                  {"Data Center\r"}
                </th>
                <th className={"w-20"} align={"left"}>
                  {"Tenant Name"}{" "}
                </th>
                <th className={"w-15"} style={{ textAlign: "right" }}>
                  {" "}
                  {"Sq Ft Leased\r"}
                </th>
                <th
                  className={"w-25"}
                  align={"left"}
                  style={{ paddingLeft: "15px" }}
                >
                  {" "}
                  {"Service Locations\r"}
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredTenantList && filteredTenantList.length > 0 ? (
                (filteredTenantList || []).map((item, index) => (
                  <tr key={"tenants" + index}>
                    <td>{item.Site == null ? "-" : item.Site}</td>
                    <td>{item.TenantName}</td>
                    <td style={{ textAlign: "right" }}>
                      {item.SqFt == 0 || item.SqFt == null
                        ? "-"
                        : item.SqFt.toLocaleString()}
                    </td>
                    <td style={{ paddingLeft: "15px" }}>
                      {item.ServiceLocations ? (
                        item.ServiceLocations &&
                        item.ServiceLocations.split(",").length <= 2 ? (
                          item.ServiceLocations.split(",")?.map(
                            (obj, index) => (
                              <Chip
                                key={"chip" + index + "c"}
                                label={obj}
                                style={{
                                  margin: 1,
                                  fontSize: "0.7rem",
                                  height: "1.8rem"
                                }}
                              />
                            )
                          )
                        ) : (
                          <>
                            {item.ServiceLocations.split(",")
                              .slice(0, 2)
                              ?.map((obj, index) => (
                                <Chip
                                  key={"chip" + index + "c"}
                                  label={obj}
                                  style={{
                                    margin: 1,
                                    fontSize: "0.7rem",
                                    height: "1.8rem"
                                  }}
                                />
                              ))}
                            <span
                              style={{ cursor: "pointer", fontSize: "0.7rem" }}
                              onClick={() =>
                                this.handleViewSuite(
                                  true,
                                  item.ServiceLocations
                                )}
                            >
                              {" ...View all"}
                            </span>
                          </>
                        )
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={{ textAlign: "center" }} colSpan={9}>
                    {"No data available\r"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <></>
        )}

        <Dialog
          open={viewAllSuite || false}
          onClose={() => this.handleViewSuite(false, "")}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {"Service Locations"}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"start"}
                color={"inherit"}
                onClick={() => this.handleViewSuite(false, "")}
                aria-label={"close"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {selectedServiceLocations &&
              selectedServiceLocations
                .split(",")
                ?.map((obj, index) => (
                  <Chip
                    key={"chip" + index + "c"}
                    label={obj}
                    style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                  />
                ))}
          </DialogContent>
          <DialogActions>
            <Button
              color={"primary"}
              onClick={() => this.handleViewSuite(false, "")}
            >
              {"Close\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withRouter(TenantViewTable);
